import React, {Component} from 'react';

var favorites = JSON.parse(localStorage.getItem('favorites')) || [];

class AddToFavorites extends Component {

    constructor() {
        super();
        this.state = {
            favorites: favorites

        };

    }

    favorite(e) {

        var id = e.target.id,
            item = e.target,
            index = favorites.indexOf(id);

        console.log(id);

        if (!id) 
            return;
        
        // item is not favorite
        if (index === -1) {
            favorites.push(id);
            item.className += ' fav';
            // item is already favorite
        } else {
            favorites.splice(index, 1);
            item.className = 'brewery';
        }
        // store array in local storage
        localStorage.setItem('favorites', JSON.stringify(favorites));
    }

    isTermInFavorites(theTerm) {

        var favorites = this.state.favorites;

        for (var i = 0; i < favorites.length; i++) {

            if (favorites[i] === theTerm) {

                return ' fav';
            }

        }

        return '';
    }

    render() {

        return (
            <div
                className={"brewery" + this.isTermInFavorites(this.props.brewery)}
                id={this.props.brewery}
                onClick={this
                .favorite
                .bind(this)}></div>

        )

    }

}

export default AddToFavorites;


/** WEBPACK FOOTER **
 ** ./src/AddToFavorites.js
 **/